export type Email = {
  to: String;
  subject: String;
  body: String;
};

export default function emailBasedOnEnv(hostName: string) {
  return hostName.startsWith("my.thoughtworks.net")
    ? "gits-support@thoughtworks.com"
    : "support@thoughtworks1405005964.zendesk.com";
}

export function generateEmailQuery(email: Email) {
  // @ts-ignore
  const subject = email.subject.replaceAll(" ", "+");
  // @ts-ignore
  const body = email.body.replaceAll(" ", "%20").replaceAll("\n", "%0A");
  const baseURL = "https://mail.google.com/mail/u/0/";
  return `${baseURL}?fs=1&tf=cm&to=${email.to}&su=${subject}&body=${body}`;
}
